import ReactDOM from "react-dom";
import React from "react";
import {Provider} from "react-redux";
import store from "../products/product-page/data-services/store";
import QuotesGallery from "../galleries/quote-gallery/quote-gallery";
import NewsAndStories from "./news-and-stories/news-and-stories";
import ArtistsQuotes from "./artists-quotes/artists-quotes";
import Chips from "./chips/chips";
import {initChipsGallery} from "./chips/data-helper";
import {getJSONFromHtml} from "../../domain/common";
import LivePagePopup from "./live-page-popup/live-page-popup";


//https://wavesaudio.atlassian.net/browse/DSWEB-2649
// Created By Raz Liveyatan
const $quotesGalleryApp = document.getElementById('product-quote-gallery-app');
if ($quotesGalleryApp)
{
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={ store }>
                <QuotesGallery />
            </Provider>
        </React.StrictMode>,
        $quotesGalleryApp
    );
}


//https://wavesaudio.atlassian.net/browse/DSWEB-2649
// Created By Raz Liveyatan
const $newsAndStoriesApp = document.getElementById('news-and-stories-app');
if ($newsAndStoriesApp)
{
    let props = {
        isShowVideoGeneralDetails:true,
    }
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={ store }>
                <NewsAndStories props={props}/>
            </Provider>
        </React.StrictMode>,
        $newsAndStoriesApp
    );
}


//https://wavesaudio.atlassian.net/browse/DSWEB-2649
// Created By Raz Liveyatan
const $videosAndBlogsApp = document.getElementById('videos-and-blogs-app');
if ($videosAndBlogsApp)
{
    let props = {
        source: 'videos-and-blogs-data',
        title: 'eMotion LV1 Powering Shows & Live Streams',
        isShowHalf:true,
        isShowVideoGeneralDetails:false,
        bgClass:'',
        textClass:'',
        generalArrowStyle:'210px'
    }
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={ store }>
                <NewsAndStories props={props}/>
            </Provider>
        </React.StrictMode>,
        $videosAndBlogsApp
    );
}

//https://wavesaudio.atlassian.net/browse/DSWEB-2649
// Created By Raz Liveyatan
const $artistsQuotesApp = document.getElementById('artists-quotes-app');
if ($artistsQuotesApp)
{
    let props = {
        source: 'artists-quotes-data',
    }
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={ store }>
                <ArtistsQuotes props={props}/>
            </Provider>
        </React.StrictMode>,
        $artistsQuotesApp
    );
}

//https://wavesaudio.atlassian.net/browse/DSWEB-2650
// Created By Raz Liveyatan
const $chipsFilterApp = document.getElementById('chips-filter-app');
if ($chipsFilterApp)
{
    const chipsGalleryProps = initChipsGallery('chips-filter-app');
    ReactDOM.render(
        <React.StrictMode>
            <Chips chipsGalleryProps={chipsGalleryProps}/>
        </React.StrictMode>,
        $chipsFilterApp
    );
}

//https://wavesaudio.atlassian.net/browse/DSWEB-2650
// Created By Raz Liveyatan
const initPopups =() => {
    const $elPopupItems = document.querySelectorAll('[data-type="live-popup"]');
    if ($elPopupItems && $elPopupItems.length > 0){
        $elPopupItems.forEach(function(el:any) {
            const $currentEl = el;
            $currentEl.addEventListener('click',  function (){
                const $popupApp = document.getElementById('live-popups-app');
                if($popupApp){
                    const $popupData = getJSONFromHtml(document.getElementById('live-popups-data'));
                    if ($popupData){
                        const elPopupId = $currentEl.getAttribute('data-id');
                        const popupData = $popupData.popupsDataRoot.filter((popup:any) => popup.id === elPopupId);
                        if (popupData && popupData.length > 0){
                            ReactDOM.render(
                                <React.StrictMode>
                                    <LivePagePopup key={`live-popup-${popupData[0].id}-${popupData[0].skuName}`} props={popupData[0]}/>
                                </React.StrictMode>,
                                $popupApp
                            );
                        }

                    }
                }
            }, false);
        })
    }
}


//https://wavesaudio.atlassian.net/browse/DSWEB-2650
// Created By Raz Liveyatan
/**
 * entry point for popups
 */
window.addEventListener('DOMContentLoaded', (event) => {
    initPopups();
});



